import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Star } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, theme }) {
  const { addToCart } = useCart();
  const accentColor = theme?.accentColor || "#c9a84c";
  const primaryColor = theme?.primaryColor || "#6b2118";

  const handleAdd = (e) => {
    e.preventDefault();
    addToCart(product, 1);
  };

  return (
    <Link to={`/product/${product.id}`} style={{ textDecoration: "none" }}>
      <div style={{
        background: "#fff", borderRadius: 16,
        overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
        border: "1px solid rgba(0,0,0,0.06)",
        transition: "transform 0.25s, box-shadow 0.25s",
        cursor: "pointer",
      }}
        onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 36px rgba(0,0,0,0.13)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.07)"; }}
      >
        {/* Image */}
        <div style={{ position: "relative", aspectRatio: "1", background: "#fdf6e3", overflow: "hidden" }}>
          {product.imageUrl ? (
            <img src={product.imageUrl} alt={product.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 8 }}>
              <div style={{ fontSize: "3rem" }}>🌾</div>
              <span style={{ fontSize: "0.75rem", color: "#999" }}>ACHU Health Mix</span>
            </div>
          )}
          {product.badge && (
            <div style={{
              position: "absolute", top: 12, left: 12,
              background: primaryColor, color: "#fff",
              padding: "4px 10px", borderRadius: 20,
              fontSize: "0.7rem", fontWeight: 700,
            }}>{product.badge}</div>
          )}
          {!product.inStock && (
            <div style={{
              position: "absolute", inset: 0, background: "rgba(0,0,0,0.45)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <span style={{ color: "#fff", fontWeight: 700, fontSize: "1rem" }}>Out of Stock</span>
            </div>
          )}
        </div>

        {/* Info */}
        <div style={{ padding: "16px 16px 20px" }}>
          <div style={{ fontSize: "0.72rem", color: "#999", letterSpacing: 1, textTransform: "uppercase", marginBottom: 4 }}>
            {product.weight || "Health Mix"}
          </div>
          <h3 style={{ fontSize: "1rem", fontWeight: 700, color: "#2c1810", marginBottom: 6, lineHeight: 1.3 }}>{product.name}</h3>
          <p style={{ fontSize: "0.78rem", color: "#777", marginBottom: 14, lineHeight: 1.5 }}>
            {product.shortDesc || "100% Natural Multi Grain Drink · 27 Grains"}
          </p>

          {/* Rating */}
          {product.rating > 0 && (
            <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 12 }}>
              {[1,2,3,4,5].map(s => (
                <Star key={s} size={12} fill={s <= product.rating ? accentColor : "none"} color={accentColor} />
              ))}
              <span style={{ fontSize: "0.72rem", color: "#999" }}>({product.reviewCount || 0})</span>
            </div>
          )}

          {/* Price + Add */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div>
              <span style={{ fontSize: "1.2rem", fontWeight: 800, color: primaryColor }}>₹{product.price}</span>
              {product.originalPrice && product.originalPrice > product.price && (
                <span style={{ fontSize: "0.78rem", color: "#bbb", textDecoration: "line-through", marginLeft: 8 }}>₹{product.originalPrice}</span>
              )}
            </div>
            <button onClick={handleAdd} disabled={!product.inStock} style={{
              background: product.inStock ? primaryColor : "#ccc",
              color: "#fff", border: "none",
              width: 36, height: 36, borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center",
              cursor: product.inStock ? "pointer" : "not-allowed",
              transition: "background 0.2s",
            }}>
              <ShoppingCart size={16} />
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}
